import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ServicesHeader extends Component {
   render() {

      return (
         <header id="services-header">

            <nav id="nav-wrap">
               <a className="mobile-btn" href="#nav-wrap" title="Show navigation">Show navigation</a>
               <a className="mobile-btn" href="#home" title="Hide navigation">Hide navigation</a>
               <ul id="nav" className="nav">
                  <li><Link to="/#home">Home</Link></li>
                  <li><Link to="/#about">About</Link></li>
                  <li><Link to="/services" className="current"> Services</Link></li>
                  <li><a className="smoothscroll" href="#gallery">Gallery</a></li>
                  <li><a className="smoothscroll" href="#contact">Contact</a></li>
               </ul>
            </nav>

            <div className="row banner">
               <div className="banner-text">
                  <h1 className="responsive-headline">Our Services</h1>
                  <h3>Details on our extensive range of luxury packages</h3>
                  <hr />
               </div>
            </div>

            <p className="scrolldown">
               <a className="smoothscroll" href="#services"><i className="icon-down-circle"></i></a>
            </p>

         </header>
      );
   }
}

export default ServicesHeader;
